import type { MonitorColorBy } from "../../../api/monitors";

// Общата палитра за оцветяване на редовете на монитора — единственото място,
// от което я четат и решетката, и списъкът (преди беше дублирана в 3 файла).
// Два набора: светли пастели (светла тема) и приглушени тъмни нюанси на
// СЪЩИЯ оттенък (тъмна тема); изборът идва от компонента през useIsDarkTheme.
export const PASTEL_COLORS = [
  "#FFD4D4",
  "#FFE4CC",
  "#FFF4CC",
  "#D4F4DD",
  "#D4E4FF",
  "#E4D4FF",
  "#FFD4F4",
  "#FFE4E4",
  "#D4FFE4",
  "#E4F4FF",
  "#F4E4D4",
  "#FFE4D4",
];

// Индекс по индекс огледало на PASTEL_COLORS в тъмен, приглушен вариант.
export const PASTEL_COLORS_DARK = [
  "#4a2b2b",
  "#4a382b",
  "#4a422b",
  "#2b4032",
  "#2b364a",
  "#382b4a",
  "#4a2b44",
  "#452e2e",
  "#2b4536",
  "#2b3c4a",
  "#42382b",
  "#4a332b",
];

export const getPastelColor = (key: string, isDark = false): string => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    const char = key.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  const palette = isDark ? PASTEL_COLORS_DARK : PASTEL_COLORS;
  return palette[Math.abs(hash) % palette.length];
};

// Усилен вариант за верига основен продукт + добавки.
export const enhanceColor = (color: string): string => {
  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const factor = 0.9;
  return `#${Math.floor(r * factor)
    .toString(16)
    .padStart(2, "0")}${Math.floor(g * factor)
    .toString(16)
    .padStart(2, "0")}${Math.floor(b * factor)
    .toString(16)
    .padStart(2, "0")}`;
};

// Цветът на реда според настройката „Оцветяване" на монитора:
// по маса (както досега), по сервитьор, или без цвят (undefined).
export const rowColorFor = (
  colorBy: MonitorColorBy,
  tableName: string,
  waiterName: string,
  isDark = false,
): string | undefined => {
  if (colorBy === "none") return undefined;
  return getPastelColor(colorBy === "waiter" ? waiterName : tableName, isDark);
};
